import { render, staticRenderFns } from "./SimulationModal.vue?vue&type=template&id=15754722&scoped=true&"
import script from "./SimulationModal.vue?vue&type=script&lang=js&"
export * from "./SimulationModal.vue?vue&type=script&lang=js&"
import style0 from "./SimulationModal.vue?vue&type=style&index=0&id=15754722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15754722",
  null
  
)

export default component.exports